var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59967 5.06986L11.4281 7.89826L4.82843 14.4979H2V11.6695L8.59967 5.06986ZM9.54247 4.12705L10.9567 2.71284C11.2171 2.45249 11.6391 2.45249 11.8995 2.71284L13.7851 4.59846C14.0455 4.8588 14.0455 5.28092 13.7851 5.54127L12.3709 6.95548L9.54247 4.12705Z",
    fill: "#6F7376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalEditIcon);
export default __webpack_public_path__ + "static/media/local-edit-icon.6de79c9135b0c1570c69d98acc7d472a.svg";
export { ForwardRef as ReactComponent };